import { supabase } from "@/integrations/supabase/client";

export interface BlogFaq { question: string; answer: string }
export interface BlogComparative { label: string; value: string; note?: string }
export interface BlogSource { label: string; url: string }
export interface BlogTypology { name: string; area?: string; bedrooms?: string; price?: string; notes?: string }
export interface BlogDifferential { title: string; description?: string }

export interface BlogPost {
  id: string;
  slug: string;
  title: string;
  subtitle: string | null;
  cover_image: string | null;
  content: string;
  excerpt: string | null;
  author: string | null;
  tags: string[];
  meta_description: string | null;
  keywords: string | null;
  is_published: boolean;
  published_at: string | null;
  similar_listing_ids: string[];
  created_at: string;
  updated_at: string;

  // Novos campos SEO / estruturados
  seo_title?: string | null;
  canonical_url?: string | null;
  og_image?: string | null;
  twitter_card?: string | null;
  schema_type?: string | null;
  geo_region?: string | null;

  faqs?: BlogFaq[];
  comparatives?: BlogComparative[];
  sources?: BlogSource[];
  typologies?: BlogTypology[];
  differentials?: BlogDifferential[];

  general_info?: Record<string, any>;
  location_info?: Record<string, any>;
  audience?: Record<string, any>;
  market_data?: Record<string, any>;
  airbnb_data?: Record<string, any>;
  condo_info?: Record<string, any>;
  ai_content?: Record<string, any>;
  cta?: Record<string, any>;
  geo?: Record<string, any>;

  related_neighborhoods?: string[];
  related_launch_ids?: string[];
}

export async function fetchPublishedPosts(): Promise<BlogPost[]> {
  const { data, error } = await supabase
    .from("blog_posts" as any)
    .select("*")
    .eq("is_published", true)
    .order("published_at", { ascending: false });
  if (error) throw error;
  return (data || []) as unknown as BlogPost[];
}

export async function fetchAllPosts(): Promise<BlogPost[]> {
  const { data, error } = await supabase
    .from("blog_posts" as any)
    .select("*")
    .order("created_at", { ascending: false });
  if (error) throw error;
  return (data || []) as unknown as BlogPost[];
}

export async function fetchPostBySlug(slug: string): Promise<BlogPost | null> {
  const { data, error } = await supabase
    .from("blog_posts" as any)
    .select("*")
    .eq("slug", slug)
    .eq("is_published", true)
    .maybeSingle();
  if (error) throw error;
  return (data as unknown as BlogPost) || null;
}
